import React from 'react';
import Hyperlink from '../Hyperlink/Hyperlink';
import './Sections.scss';
import Quiz from '../Quiz/Quiz';

function Section3() {
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/magazine/real-estate-news/10-housing-markets-expected-to-lead-the-nation-in-2023',
      copy: 'NAR has identified 10 markets, primarily in the Southeast',
      label: 'Read article, 10 Housing Markets Expected to Lead the Nation in 2023'
    },
    {
      href: 'https://www.nar.realtor/magazine/real-estate-news/mortgage-rates-settle-into-the-6-range',
      copy: 'that could help convince some potential sellers to list their homes',
      label: 'Read article, Mortgage Rates Settle Into the 6% Range'
    }
  ];
  return (
    <section className="sections">
      <h3 className="sections-sub">3. National Stability, Regional Variability</h3>
      <p className="sections-copy sections-copy--margin">
        Based on his data analysis, Yun forecasts that housing prices will largely hold steady on
        the national level in 2023. On a regional or local level, however, he acknowledges that some
        places will likely see small price gains, while other places – especially expensive markets
        on the West Coast – may see downward price adjustments when sellers who want to relocate
        find there are no buyers at current prices.
      </p>
      <Quiz />
      <p className="sections-copy sections-copy--margin">
        On the flip side, <Hyperlink hyperlinkData={hyperlinkData[0]} />, that Yun believes are
        poised to outperform the rest of the country in 2023. “These are cities where you have a
        combination of good job creation and relatively affordable price,” he says. “In these
        markets, demand for housing continues to outpace supply and prevailing economic conditions
        provide support for home prices to climb by at least 5% in 2023.”
      </p>

      <h3 className="sections-title">PREDICTIONS ARE GOOD, BUT REFINANCING MAY BE BETTER</h3>

      <p className="sections-copy">
        Yun is not quite ready to say that we will never see 30-year mortgage interest rates fall
        below 3% again, but he does believe that the sub-3% rates of 2020 and 2021 were a historical
        anomaly that may not reoccur for decades.
      </p>

      <p className="sections-copy">
        Instead, Yun predicts a new normal financing environment where 30-year fixed mortgage rates
        fluctuate in the 5% range, sometimes dipping down to 4%, and other times closer to 6%.
      </p>
      <p className="sections-copy">
        Even though the days of ultra-low rates may be behind us, long-term trends indicate that
        buying a home generally is still a good investment. Consider the latest Federal Reserve data
        showing that homeowners had 40-times greater median net worth ($255,000) compared to renters
        ($6,300).
      </p>
    </section>
  );
}

export default Section3;
